export enum factoryCategoryEnum {
  A类 = 1,
  B类 = 2,
  C类 = 3,
  D类 = 4,
  E类 = 5,
}
